import { render, staticRenderFns } from "./GroupDetail.vue?vue&type=template&id=ca621d58&scoped=true&"
import script from "./GroupDetail.vue?vue&type=script&lang=ts&"
export * from "./GroupDetail.vue?vue&type=script&lang=ts&"
import style0 from "./GroupDetail.vue?vue&type=style&index=0&id=ca621d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca621d58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca621d58')) {
      api.createRecord('ca621d58', component.options)
    } else {
      api.reload('ca621d58', component.options)
    }
    module.hot.accept("./GroupDetail.vue?vue&type=template&id=ca621d58&scoped=true&", function () {
      api.rerender('ca621d58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Card/Groups/GroupDetail.vue"
export default component.exports